<template>
    <v-layout row wrap class="pl-3 pr-2">
        <confirmation-header-text text="Business detail" class="ml-2"
                                  icon="mdi-alpha-b-box"></confirmation-header-text>

        <v-flex sm3 xs6>
            <list-item-detail
                    :sub_title="application_data.name_of_business_institute"
                    title="Name of business institution"/>
        </v-flex>
        <v-flex sm3 xs6>
            <list-item-detail
                    :sub_title="application_data.address_of_business_institute"
                    title="Full address"/>
        </v-flex>
        <v-flex sm3 xs6>
            <list-item-detail
                    :sub_title="application_data.business_from+'-'+application_data.business_to"
                    title="Business Duration"/>
        </v-flex>
    </v-layout>
</template>

<script>
    import ListItemDetail from "../../ListItemDetail";
    import ConfirmationHeaderText from "../../ConfirmationHeaderText";

    export default {
        computed: {
            application_data() {
                return this.$store.state.VisaRequestSingle.visaRequest.extra.application_data;
            }
        },
        components: {
            ListItemDetail,
            ConfirmationHeaderText
        }
    };
</script>

<style>
</style>
